import { href, Link } from 'react-router'
import type { DetailField } from '~/schemas/products'

function renderDetailValue(d: DetailField) {
  switch (d.type) {
    case 'text':
      return d.value
    case 'number':
      return (
        <>
          {d.value}
          {d.unit ? ` ${d.unit}` : null}
        </>
      )
    case 'boolean':
      return d.value ? 'Ja' : 'Nee'
    case 'string_list':
      // kies: comma-joined, of “chips”
      // return d.value.join(', ')
      // of als chips:
      return (
        <div className="flex flex-wrap gap-1">
          {d.value.map((v, i) => (
            <span key={i} className="rounded-(--ws-radius-inner) bg-(--ws-surface-2) px-2 py-0.5 text-xs">
              {v}
            </span>
          ))}
        </div>
      )
    case 'dimension':
      // vaak zit de eenheid al in value; maar voeg unit toe als die los staat
      return (
        <>
          {d.value}
          {d.unit ? ` ${d.unit}` : null}
        </>
      )
    case 'json':
    default:
      // voorzichtig formatteren
      return <code className="break-all">{JSON.stringify(d.value)}</code>
  }
}

export function ProductDetails({
  details,
  ean,
  category,
  categoryKey,
  categoriesEnabled
}: {
  details: DetailField[]
  ean?: string
  category?: string
  categoryKey?: string
  categoriesEnabled?: boolean
}) {
  if (!details?.length && !ean && !category) return null

  return (
    <div className="mt-4">
      <div className="text-sm font-semibold tracking-wide text-(--ws-text-muted) uppercase">Productdetails</div>
      <ul className="mt-2 divide-y divide-(--ws-border)">
        {category && (
          <li className="grid grid-cols-2 gap-3 py-2">
            <div className="text-(--ws-text-muted)">Categorie</div>
            <div className="font-medium text-(--ws-text)">
              {categoriesEnabled && categoryKey ? (
                <Link to={href('/category/:key', { key: categoryKey })} className="text-(--ws-link) hover:underline">
                  {category}
                </Link>
              ) : (
                category
              )}
            </div>
          </li>
        )}
        {ean && (
          <li className="grid grid-cols-2 gap-3 py-2">
            <div className="text-(--ws-text-muted)">EAN</div>
            <div className="font-medium text-(--ws-text)">{ean}</div>
          </li>
        )}
        {details.map(d => (
          <li key={d.key} className="grid grid-cols-2 gap-3 py-2">
            <div className="text-(--ws-text-muted)">{d.label}</div>
            <div className="font-medium text-(--ws-text)">{renderDetailValue(d)}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}
